import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./LandingPage.css";
import { Link } from "react-router-dom";

function LandingPage() {
  const navigate = useNavigate();

  useEffect(() => {
    document.body.style.backgroundColor = "#930203";

    // Redirect to dashboard if user is already logged in
    const user = localStorage.getItem("user");
    if (user) {
      navigate("/dashboard");
    }

    return () => {
      document.body.style.backgroundColor = "";
    };
  }, [navigate]);

  return (
    <div
      className="landing-page"
      style={{
        background: "linear-gradient(180deg, #930203 0%, #690202 40%)",
        minHeight: "100dvh",
        overflow: "hidden",
        position: "fixed",
        width: "100%"
      }}
    >
      <div className="sec-break" style={{ height: "100px" }}></div>

      <div
        className="logo-horizon"
        style={{ backgroundImage: "url(/images/Ellipse.png)" }}
      ></div>

      <div className="logo-display container d-flex flex-column align-items-center mt-5 justify-content-center">
        <div className="logo mt-5 opacity-75">
          <img
            src="images/logo.png"
            alt="YZH logo"
            style={{ width: "40px", height: "auto" }}
          />
        </div>
        <div className="logo-heading d-flex mt-1 text-white text-center justify-content-center align-items-center">
          <h1>
            FicReader
          </h1>
        </div>
        <div className="logo-subtitle text-white opacity-50 mb-4">
          <p>aka the tomarry goonvault</p>
        </div>

        <Link
          to="/signin"
          className="sign-in-btn mt-4 w-75"
          style={{ textDecoration: "none" }}
        >
          Log In
        </Link>
        <Link
          to="/signup"
          className="sign-up-btn mt-3 w-75"
          style={{ textDecoration: "none" }}
        >
          Sign Up
        </Link>
      </div>
    </div>
  );
}

export default LandingPage;
